import { motion } from 'framer-motion';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { appIconTypes } from 'global/enums/appIconTypes';
import _ from 'lodash';
import { useContext, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icon, Label } from 'semantic-ui-react'; // or your preferred icon library
import SortableGrid from 'SortableGrid';
import { _squareTypes } from './SquareSquares';
import { settingsIconTypes } from 'global/enums/settingsIconTypes';
import { SquaresContext } from './SquaresWrapper';
import { convertHelpers } from 'global/common/convert';

const _iconSize = null

// Example transition — replace with your actual itemTransition if imported
const itemTransition = { duration: 0.25, ease: 'easeOut' };

export const _imsTypes = {
  normal: 'normal',
  inline: 'inline',
  match: 'match',
  event: 'event',
}

const ItemMenuSquares = ({
  activeItem,
  caption,
  currentData,
  group,
  icon: icon_main,
  iconn: iconn_main,
  access: access,
  iconItem: icon_item,
  iconColor: _iconColor,
  imsType = _imsTypes.normal,
  menuItems,
  noItemIcon,
  onCancel,
  onClick,
  onDrop,
  squareType,
  withCancel,
  fn_altContent,
  fnAltData,
  isFull,
  noGap,
}) => {

  const _menuItems = _.cloneDeep(menuItems)

  if (!_.isArray(_menuItems)) {
    convertHelpers.createItemKeys(_menuItems, 'key')
  }

  let isInline = imsType === _imsTypes.inline

  const { showShow, allowGroups, allowSorting, allowSections, allowAltItem } = useMemo(() => {
    let _allowSorting = false
    let _allowGroups = false
    let _showShow = false;
    let _allowSections = false
    let _allowAltItem = false

    switch (squareType) {
      case _squareTypes.pages_global:
        _allowGroups = true
        _allowSorting = true
        break;
      case _squareTypes.pages_page:
        _allowGroups = true
        _allowSorting = true
        _showShow = true
        break;
      case _squareTypes.pageProps:
        _allowGroups = true
        _allowSorting = true
        _showShow = true
        _allowSections = fnAltData ? true : false
        break;
      case _squareTypes.pageSections:
        _allowSorting = true
        _showShow = true
        _allowSections = fnAltData ? true : false
        break;
      case _squareTypes.pageItems:
        _allowAltItem = true
        break;
      default:
      // nothing
    }
    return { showShow: _showShow, allowGroups: _allowGroups, allowSorting: _allowSorting, allowSections: _allowSections, allowAltItem: _allowAltItem }
  }, [squareType])

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { themeColors } = aps_global ?? {}

  const squaresContext = useContext(SquaresContext)
  const { squares_handlers } = squaresContext ?? {}

  const [showReorder, setShowReorder] = useState()

  const handleShow_reorder = () => setShowReorder(!showReorder)
  const handleShow_sections = () => {
    const ps = fnAltData()
  }

  const cnc = [
    'item-menu-squares-container',
    imsType,
    !caption && 'nc',
    (allowSorting || allowGroups) && 'srt',
    showReorder && ' srdr',
    (noGap && 'ng')
  ].filter(Boolean).join(' ')

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files) => {
      onDrop(files)
    },
    accept: {
      'image/*': [],
      'application/pdf': [],
    },
    multiple: true,
  })

  const handleCancel = (e) => {
    e && e.stopPropagation()
    onCancel()
  }

  const itemCaption = (c) => c && <div className='sqr-box-caption'>{c} </div>

  // const itemLabel = (icon, colors) => <Label className='sqr-box-icon' style={{ backgroundColor: colors.bg, color: colors.c }}>
  //   {icon}
  // </Label>

  const itemIcon = (item, itemKey, icon, iconColor, disabled, colors) => <div className='sqr-box-icon'>
    <Icon
      className='ims-item-icon'
      name={appIconTypes[itemKey] || colors?.icon || icon}
      color={iconColor || 'blue'}
      size={_iconSize}
      disabled={disabled}
      circular={showShow}
      inverted={showShow && item.show}
      onClick={(e) => onCancel && handleCancel(e)}
    />
  </div>

  const div_inline = (divProps) => {
    const { item, itemKey, caption, count, icon, iconColor, isHeader, altContent, allowAltItem, disabled, colors } = divProps
    const { color } = item ?? {}
    const _iconColor = color || iconColor
    return <div className='sqr-box'>
      {itemCaption(caption)}
      {!_.isNumber(count) && !isHeader && !noItemIcon && itemIcon(item, itemKey, icon, _iconColor, disabled, colors)}
      {_.isNumber(count) && !isHeader && <Label className='sqr-box-icon' circular size={'tiny'} color={'blue'}>{item.count}</Label>}
      {altContent && !isHeader && <div className='sqr-box-oth'>{altContent}</div>}
      {fn_altContent && !isHeader && <div className='sqr-box-oth'>{fn_altContent(item, itemKey)}</div>}
      {/* {allowAltItem && altItem && <div className='sqr-box-oth' style={{ color: 'var(--off-white-5' }} onClick={(e) => _onClick && !disabled && !showReorder && !isHeader && handleAltClick(e, altItem, group)}>{altItem?.caption}</div>} */}
      {colors.bg &&
        <Label size='mini' className='sqr-box-oth' style={{ backgroundColor: colors.bg, color: colors.c }}>
          {'A'}
        </Label>}
    </div>
  }

  const div_normal = (divProps) => {
    const { item, itemKey, caption, count, icon, iconColor, isHeader, altContent, disabled, captionCount } = divProps
    return <div className='sqr-box mtl'>
      {itemCaption(caption)}
      {!_.isNumber(count) && !isHeader && itemIcon(item, itemKey, icon, iconColor, disabled)}
      {_.isNumber(captionCount) && !isHeader && <Label className='sqr-box-oth' size={'mini'}>{captionCount}</Label>}
      {altContent && !isHeader && <div className='sqr-box-oth'>{altContent}</div>}
    </div>
  }

  const div_match = (divProps) => {
    const { item } = divProps
    return <div className='sqr-box'>
      {itemCaption(item?.key || item?.name)}
    </div>
  }

  const div_event = (divProps) => {
    const { item } = divProps
    const { name } = item
    return <div className='sqr-box evt'>
      {itemCaption(name || item?.key)}
    </div>
  }

  const divItem = (divProps) => {
    switch (imsType) {
      case _imsTypes.inline:
        return div_inline(divProps)
      case _imsTypes.normal:
        return div_normal(divProps)
      case _imsTypes.match:
        return div_match(divProps)
      case _imsTypes.event:
        return div_event(divProps)
      default:
        return div_inline(divProps)
    }
  }

  const renderIconDiv = (item, itemKey) => {
    const {
      _isFirstItem,
      caption,
      count,
      data,
      disabled,
      icon,
      iconColor,
      isDrop,
      isHeader,
      key,
      name,
      selected,
      text,
      subText,
      triggerUrl,
      ui,
      altContent,
    } = item ?? {}


    let altItem;

    if (allowAltItem && item.key === 'props') {
      altItem = _.cloneDeep(item)
      altItem.key = 'propSections'
      altItem.caption = 'Prop Sections'
    }

    let _caption;
    let _icon = withCancel ? 'delete' : icon_item ? icon_item : 'arrow right';
    let _iconColor;
    let _key;
    let _captionCount;
    let _selected = activeItem && ((activeItem === name) || activeItem === item)

    if (_.isObject(item)) {
      if (_.isObject(caption)) {
        _caption = caption.text || _.startCase(itemKey)
        _captionCount = caption?.count || null
      } else {
        _caption = caption || _.startCase(itemKey)
      }
      if (icon) { _icon = icon }
      if (iconColor) { _iconColor = iconColor }
      if (key) { _key = key }
    } else {
      _caption = _.startCase(item)
    }

    if (ui?.caption) { _caption = `${ui?.caption} - ${data?.formItemType}` }
    if (text) { _caption = `${text}` }
    if (name) { _caption = `${name}` }
    _caption = _.startCase(_caption)

    const _cnd = [
      'imsc-item',
      selected && 'sel',
      isHeader && 'hdr',
      _selected && 'sel'
    ].filter(Boolean).join(' ')

    if (triggerUrl) { _iconColor = ' orange' }

    let _colors = { bg: null, c: null, icon: null }

    switch (group?.key) {
      case 'style':
      case 'styles':
      case 'themedColors':
      case 'themedItems':
        const propData = currentData?.[item.key]
        const { colors } = propData ?? {}
        const { backgroundColor, color } = colors ?? {}
        const _bgcolor = themeColors?.[backgroundColor]
        const _color = themeColors?.[color]
        _colors.bg = _bgcolor
        _colors.c = _color
        _colors.icon = settingsIconTypes[item.key]
        break;
      default:
      // nothing
    }

    const _isDrop = isDrop
    // if (isDrop) currentDropItem = item

    // on drop
    const grp = getRootProps()
    const _onClick = _isDrop ? grp.onClick : onClick
    delete grp.onClick

    const handleAltClick = (e, item, group) => {
      e.stopPropagation()
      _onClick(item, group)
    }

    if (_isFirstItem) return (
      <motion.div>
        <div style={{ padding: '.25em', textAlign: 'center' }}>
          <Icon name={'object ungroup outline'}
            color={'blue'}
            style={{ marginRight: '1em' }}
          />
          {_.startCase(item?.propSection)}
        </div>
      </motion.div>
    )

    const divProps = {
      allowAltItem,
      altContent,
      caption: _caption,
      captionCount: _captionCount,
      colors: _colors,
      count,
      disabled,
      icon,
      icon: _icon,
      iconColor: _iconColor,
      isHeader,
      item,
      itemKey,
    }

    return (
      <motion.div
        key={itemKey}
        layout
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 6 }}
        transition={itemTransition}
        className={`${_cnd} ${isDrop && isDragActive ? 'drag-active' : ''}`}
        onClick={() => _onClick && !disabled && !showReorder && !isHeader && _onClick(item, group)}
        {...(isDrop ? grp : {})}
      >
        {/* Dropzone input only for drop items */}
        {isDrop && <input {...getInputProps()} />}
        {divItem(divProps)}
        {subText && !isHeader && <div className='ims-item-sbu'>{subText} </div>}
      </motion.div >
    )
  };

  if (_.isEmpty(_menuItems)) { return; }

  let miCount = _.size(_menuItems)
  if (miCount > 3) { miCount = 3 }
  if (miCount === 1) { miCount = 2 }


  const cni = [
    'imsc-row-item',
    `sz-${isInline ? 1 : miCount}`,
  ].filter(Boolean).join(' ')

  // let cn_cap = `imsc-caption ${isInline ? 'inl' : ''}`

  const cn_cap = [
    'imsc-caption',
  ].filter(Boolean).join(' ')

  const handle_ammendSort = (items) => {
    const _items = _.cloneDeep(items)
    _.map(_items, (item, index) => {
      item.position = index
    })
    setShowReorder()
    squares_handlers.handleAmmend_updateViewItemsInViews(_items, squareType)
    // handle_viewUpdate(_items, squareType)
  }

  if (allowSorting || allowGroups) {
    return (
      <div className={cnc} >
        {caption && <div className={cn_cap}>
          <Icon name={icon_main} color={_iconColor || 'blue'} style={{ marginRight: '1em' }} onClick={() => allowSections && handleShow_sections()} />
          {caption}
          <Icon name={'sort content ascending'} color={showReorder ? 'green' : 'grey'} style={{ marginLeft: '1em' }} onClick={() => handleShow_reorder()} />
        </div>
        }
        <div className={cni} >
          <SortableGrid
            items={_menuItems}
            divFn={renderIconDiv}
            showReorder={showReorder}
            showApply={true}
            groupKey={group?.key}
            handleSave={handle_ammendSort}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className={cnc} style={isFull ? { height: '100%', padding: '1em' } : {}} >
        {caption && <div className={cn_cap} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
          <div>
            <Icon name={icon_main} color={_iconColor || 'blue'} style={{ marginRight: '1em' }} onClick={() => handleShow_reorder()} />
            {caption}
          </div>
          <div>
            {iconn_main && <Icon name={iconn_main} color={_iconColor || 'blue'} />}
            {access && <Icon name={access?.icon || 'user'} color={access?.color || 'blue'} />}
          </div>
        </div>}
        <div className={cni} >
          {_.map(_menuItems, (item, itemKey) => renderIconDiv(item, itemKey))}
        </div>
      </div>
    );
  }

};

export default ItemMenuSquares;
